//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      columns: [
        {
            name: "product",
            align: "left",
            label: this.$t("stock.product"),
            field: "product",
            sortable: true,
            // headerStyle: "min-width: 200px",
            // style: "min-width: 200px; max-width:200px; overflow:hidden; white-space:nowrap;",
        },        {
            name: "warehouseName",
            align: "left",
            label: this.$t("stock.warehouse"),
            field: "warehouseName",
            sortable: true,
        },
        {
            name: "quantityTurnoverRate",
            align: "right",
            label: this.$t("stock.quantityTurnoverRate"),
            field: "quantityTurnoverRate",
            sortable: true,
        },
        {
            name: "storageTime",
            align: "right",
            label: this.$t("stock.storageTime"),
            field: "storageTime",
            sortable: true,
        },
      ],

      filter: "",
      Warehouses: [],
      warehouseId: 0,
      stocks: [],
      periodDaysOptions: [ { value: 30, label: this.$t("stock.last30Days") }, { value: 90, label: this.$t("stock.last90Days")}, { value: 180, label: this.$t("stock.last180Days")}, { value: 360, label: this.$t("stock.last360Days")} ],
      selectedPeriodDays: 30, 
      hideTableBottom: true,
    };
  },
  async mounted() {

    if (this.warehouses.length > 1) {
      this.Warehouses.push({ id: '0', warehouseName: 'Alle' });
    }
    for (var i = 0; i < this.warehouses.length; i++) {
      this.Warehouses.push(this.warehouses[i]);
    }
    this.warehouseId = this.Warehouses[0].id;
    
    await this.refresh();
  },

  computed: {
    ...mapState("main", ["warehouses"]),
  },

  methods: {
    ...mapActions("main", [
      "getStocksTurnoverRate"
    ]),

    async refresh() {

      this.stocks = [];
      this.filter = "";
      
      this.selectedPeriodDays = this.periodDaysOptions[0].value;

      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });
  
      this.stocks = await this.getStocksTurnoverRate({ warehouseId: this.warehouseId, selectedPeriodDays: this.selectedPeriodDays });

      setTimeout(() => {
        notif();
      }, 500);
    },

    async getStocks() {
      this.stocks = await this.getStocksTurnoverRate({ warehouseId: this.warehouseId, selectedPeriodDays: this.selectedPeriodDays });
    }
  },
};
